<template>
  <div id="modal-layout-default" class="modal__layout">
    <section class="layout__header">
      <h1 v-if="title" class="header__title" :class="{ 'header__title--center': isCollaboratorFlow }">{{ title }}</h1>
      <div v-if="icon" class="icon icon-circle">
        <span :class="['di', `di-icon-${icon}`]"></span>
      </div>
      <p class="header__message">{{ message }}</p>
    </section>
    <div class="layout__buttons">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ModalLayoutDefault',
  props: {
    title: {
      type: String,
    },
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      isCollaboratorFlow: 'global/isCollaboratorFlow',
    }),
  }
};
</script>
<style lang="scss" scoped>
.modal__layout {
  display: grid;
  height: 100%;
  grid-auto-rows: 50% 45%;
  padding: 0 16px;
}

.layout {
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;

    .icon {
      margin-bottom: 10px;
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    button:last-of-type {
      margin-top: 25px;
    }
  }
}
.header {
  &__title {
    width: 70%;

    &--center {
      text-align: center;
    }
  }

  &__message {
    color: var(--color-grey-6);
    width: 83%;
    line-height: 24px;
    margin-top: 10px;
  }
}
</style>
